export const getActionName = (store: string, action: string) =>
  `${store}/${action}`
